import { DateTimeISO, Money, PaginatedResponse } from './common';

export interface LendingRequestItem {
  uuid: string;
  loanType: string;
  loanProduct: string;
  submittedAt: DateTimeISO;
}
export interface LendingCustomerInfo {
  customerName: string;
  customerEmail: string;
  customerPhone: string;
}

export interface LendingAviation
  extends LendingCustomerInfo,
    LendingRequestItem {
  loanProduct: 'aviation';
  aircraftCondition: string;
  estimatedPurchasePrice: string;
  downPaymentAmount: string;
  requestedLoanAmount: string;
  willBeOwnedByHoldingCompany: boolean;
  aircraftDetails: string;
  grossMonthlyIncome: string;
}

export interface LendingYacht extends LendingCustomerInfo, LendingRequestItem {
  loanProduct: 'yacht';
  model: string;
  downPaymentAmount: string;
  requestedLoanAmount: string;
  estimatedCreditScore: string;
}

export interface LendingHome extends LendingCustomerInfo, LendingRequestItem {
  loanProduct: 'home';
  propertyPostalCode: string;
  residencyUsage: string;
  propertyType: string;
  downPaymentAmount: Money;
  purchasePrice: Money;
  estimatedCreditScore: string;
}

export type LoanRequestResponse = PaginatedResponse<LendingRequestItem>;

export type LoanRequestDetailsResponse =
  | LendingAviation
  | LendingYacht
  | LendingHome;

export const queryKeys = {
  list: ['lending-list'] as const,
  details: ['lending-details'] as const,
};
